import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { fetchCustomer } from '../actions/customer'

import { UNKNOWN } from '../assets/constant'


import SummaryCustomer from './SummaryCustomer'
import SummaryItems from './SummaryItems'
import SummarySize from './SummarySize'
import SummaryMode from './SummaryMode'
import SummaryPrice from './SummaryPrice'

import ErrorBoundary from './ErrorBoundary'

class SummaryApp extends React.Component {
  render() {
    return (
      <div>
        <div className="col-10 offset-1">
          <ErrorBoundary>
            <SummaryCustomer />
            <SummaryItems />
            <SummarySize />
            <SummaryMode />
            <SummaryPrice />
          </ErrorBoundary>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => bindActionCreators({ fetchCustomer }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SummaryApp)


// WEBPACK FOOTER //
// ./app/javascript/components/components/SummaryApp.jsx